export const SET_SIDEBAR = 'SET_SIDEBAR'
export const SET_THEME = 'SET_THEME'

export const setSidebar = (data) => ({ type: SET_SIDEBAR, value: data });
export const setThemeColor = (data) => ({ type: SET_THEME, value: data });


